/**
 * Делает элементы с `data-href` кликабельными как целиком карточку/блок.
 * Если клик пришел по вложенной ссылке `<a>`, приоритет остается за этой ссылкой.
 */
export class LinkHandler {
    constructor(selector = "[data-href]") {
        this.selector = selector;
    }
    init() {
        const elements = document.querySelectorAll(this.selector);
        elements.forEach((element) => {
            const url = element.getAttribute("data-href");
            if (url) {
                LinkHandler.makeClickable(element, url);
            }
        });
    }
    static makeClickable(element, url) {
        element.classList.add("cursor-pointer");
        element.addEventListener("click", (e) => {
            const target = e.target;
            // Проверяем, был ли клик по вложенной ссылке <a>
            const linkElement = target === null || target === void 0 ? void 0 : target.closest("a");
            if (linkElement && element.contains(linkElement)) {
                // Проверяем, является ли ссылка служебной (например, имеет класс или атрибут)
                if (linkElement.classList.contains("no-redirect") || linkElement.hasAttribute("data-no-redirect")) {
                    return; // Прерываем обработку клика
                }
                // Если клик по ссылке, перенаправляем на ее href
                const href = linkElement.getAttribute("href");
                if (href) {
                    window.location.href = href;
                    return;
                }
            }
            // Если клик не по ссылке, используем data-href родителя
            window.location.href = url;
        });
    }
}
